module.exports = __webpack_public_path__ + "static/media/draft.4f7e7af4.svg";